import Vue from 'vue'
import Vuex from 'vuex'
import {getTimeInterval} from '../utils/index'
import {getHomeInitData} from '@/api'

Vue.use(Vuex)
// 略：后台获取系统运行时间
var runAt = '0';
let timer = null;

// 从 localStorage 恢复缓存的数据
const STORAGE_KEY = 'blog_init_data'
function getStoredData() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (stored) {
            const parsed = JSON.parse(stored)
            return parsed
        }
    } catch (e) {
        console.warn('读取本地存储失败:', e)
    }
    return null
}

const storedData = getStoredData() || {}

const state = {
    loading: false,
    runTimeInterval: '',
    socials: storedData.socials || '',
    websiteInfo: storedData.websiteInfo || '',
    systemInfo: storedData.systemInfo || '',      // 系统配置信息
    systemIcons: storedData.systemIcons || [],     // 系统图标
    articleTypes: storedData.articleTypes || []     // 文章分类
}
const mutations = {
    SET_LOADING: (state, v) => {
        state.loading = v;
    },
    SET_SOCIALS: (state, v) => {
        state.socials = v;
    },
    SET_SITE_INFO: (state, v) =>{
      state.websiteInfo = v;
    },
    SET_SYSTEM_INFO: (state, v) => {
        state.systemInfo = v;
    },
    SET_SYSTEM_ICONS: (state, v) => {
        state.systemIcons = v;
    },
    SET_ARTICLE_TYPES: (state, v) => {
        state.articleTypes = v;
    },
    GET_RUNTIME_INTERVAL: (state) => {
        if (!timer || !state.runTimeInterval) {
            clearInterval(timer)
            timer = setInterval(() => {
                state.runTimeInterval = getTimeInterval(runAt);
            }, 1000);
        }
    }
}
const actions = {
    setLoading: ({commit}, v) => {
        commit('SET_LOADING', v);
    },
    initComputeTime: ({commit}) => {
        commit('GET_RUNTIME_INTERVAL');
    },
    getSiteInfo: ({commit,state}) =>{
        return new Promise(resolve => {
            if (state.websiteInfo){
                resolve(state.websiteInfo)
            } else if (state.systemInfo) {
                // 使用整合接口的数据
                commit('SET_SITE_INFO', state.systemInfo)
                let data = state.systemInfo
                let number = Date.parse(new Date())
                runAt = number-(data.runTime*1000)
                resolve(data)
            } else {
                // 数据还未加载，返回空对象（组件应等待首页加载完成）
                resolve({})
            }
        })
    },
    getSocials: ({commit,state}) =>{
        return new Promise((resolve => {
            if (state.socials){
                resolve(state.socials)
            } else if (state.systemIcons && state.systemIcons.length > 0) {
                // 使用整合接口的数据
                commit('SET_SOCIALS', state.systemIcons)
                resolve(state.systemIcons)
            } else {
                // 数据还未加载，返回空数组（组件应等待首页加载完成）
                resolve([])
            }
        }))
    }
}
const getters = {
    loading: state => state.loading,
    runTimeInterval: state => state.runTimeInterval,
    notice: state => state.websiteInfo?state.websiteInfo.notice:''
}
export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {},
    getters
})
